import {EMPLOYER} from '@/constants/usersTypes'

const AccountVacanciesPage = () => import(/* webpackChunkName: "account-employer" */ '../views/Account/employer/AccountVacanciesPage')
const AccountAllVacanciesPage = () => import(/* webpackChunkName: "account-employer" */ '../views/Account/employer/AccountAllVacanciesPage')
const AccountPublishedVacanciesPage = () => import(/* webpackChunkName: "account-employer" */ '../views/Account/employer/AccountPublishedVacanciesPage')
const AccountHiddenVacanciesPage = () => import(/* webpackChunkName: "account-employer" */ '../views/Account/employer/AccountHiddenVacanciesPage')
const AccountEmployerProfileEditPage = () => import(/* webpackChunkName: "account-employer" */ '../views/Account/employer/AccountEmployerProfileEditPage')
const AccountSubscription = () => import(/* webpackChunkName: "account-page" */ '../views/Account/employer/AccountSubscription')
const AccountSubscriptionBalance = () => import(/* webpackChunkName: "account-page" */ '../views/Account/employer/AccountSubscriptionBalance')
const AccountSubscriptionTariff = () => import(/* webpackChunkName: "account-page" */ '../views/Account/employer/AccountSubscriptionTariff')


export default [{
  path: 'employer',
  name: 'account-employer',
  meta: {
    requiredUserTypes: [EMPLOYER]
  },
  redirect: 'employer/profile-edit'
}, {
  path: 'profile-edit',
  name: 'account-employer-profile-edit',
  component: AccountEmployerProfileEditPage,
  meta: {
    requiredUserTypes: [EMPLOYER]
  },
}, {
  path: 'vacancies',
  name: 'account-vacancies',
  component: AccountVacanciesPage,
  meta: {
    requiredUserTypes: [EMPLOYER]
  },
  children: [{
    path: '/',
    name: 'account-vacancies',
    component: AccountAllVacanciesPage
  }, {
    path: 'published',
    name: 'account-vacancies-published',
    component: AccountPublishedVacanciesPage
  }, {
    path: 'hidden',
    name: 'account-vacancies-hidden',
    component: AccountHiddenVacanciesPage,
  }, {
    path: 'archive',
    name: 'account-vacancies-archive' // TODO use MyVacanciesArchiveList component inside page
  }]
}, {
  path: 'subscription',
  name: 'account-subscription',
  redirect: 'subscription/balance',
  component: AccountSubscription,
  children: [{
      path: 'balance',
      name: 'account-subscription-balance',
      component: AccountSubscriptionBalance,
    }, {
      path: 'tariff',
      name: 'account-subscription-tariff',
      component: AccountSubscriptionTariff,
    }]
}]
